import styled from 'styled-components';
import { breakpoints, css } from 'src/styles/theme';
import { rem } from 'polished';
import { Pages } from 'src/types/pages';
import { SummaryDealerDetailsStyled } from '../SummaryDealerDetailsStyled';

export const SummaryDealerDetailsAC = styled(SummaryDealerDetailsStyled)`
    border-bottom: ${rem('1px')} solid ${({ theme }) => theme.colors.grey16};
    border-top: ${rem('1px')} solid ${({ theme }) => theme.colors.grey16};

    .titleWrapper {
        .title,
        .sectionNumber {
            font-size: ${({ theme }) => theme.fontSizes.h2};
            color: ${({ theme }) => theme.colors.grey5};
        }
        .isClose {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.red};
                }
            }
        }
        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.red};
                }
            }
        }
    }

    .infoIcon {
        svg g {
            circle {
                fill: ${({ theme }) => theme.colors.grey2};
                stroke: ${({ theme }) => theme.colors.grey2};
            }

            line {
                stroke: ${({ theme }) => theme.colors.white};
            }
        }
    }
`;
